/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'goal-fields.goal-followers.add-followers-title': 'Přidat sledující',
  'goal-fields.goal-followers.title': 'Sledující',
  'goal-fields.goal-links.add-parent-goal-title': 'Přidat nadřazený cíl',
  'goal-fields.goal-links.edit-parent-goal-title': 'Upravit nadřazený cíl',
  'goal-fields.goal-links.unlink-parent-goal-title': 'Odpojit nadřazený cíl',
  'goal-fields.goal-metrics.automatic-metric-title': 'Z dílčích cílů',
  'goal-fields.goal-metrics.goal-metrics-info-section-dropdown-menu.remove-label': 'Odebrat',
  'goal-fields.goal-metrics.goal-metrics-info-section-dropdown-menu.settings-label': 'Nastavení',
  'goal-fields.goal-metrics.goal-metrics-info-section-dropdown-menu.show-more': 'Zobrazit více',
  'goal-fields.goal-metrics.goal-metrics-info-section-dropdown-menu.update-value-label': 'Aktualizovat hodnotu',
  'goal-fields.goal-metrics.manual-metrics-popup-content.start-value-label': 'Začátek:',
  'goal-fields.goal-metrics.manual-metrics-popup-content.target-value-label': 'Cíl:',
  'goal-fields.goal-metrics.metrics-popup.external-metric-description':
    'Průběh se automaticky vyplňuje pomocí nástroje {compass}. Tuto metriku cíle lze upravovat pouze v nástroji {compass}.',
  'goal-fields.goal-metrics.no-metrics-instructions': 'Chcete-li změnit toto pole, přejděte na úplnou stránku cíle',
  'goal-fields.goal-metrics.no-metrics-title': 'Žádná metrika',
  'goal-fields.goal-metrics.open-in-new-window-label': 'Otevřít v novém okně',
  'goal-fields.goal-metrics.percentage-metric-completion-percentage.description': 'dosažený průběh',
  'goal-fields.goal-metrics.rollup-metric-title-no-sub-goals': 'Nemáte připojené žádné dílčí cíle s metrikami',
  'goal-fields.goal-metrics.title': 'Průběh',
  'goal-fields.goal-owner.title': 'Vlastník',
  'goal-fields.goal-start-date.add-start-date-title': 'Přidat datum zahájení',
  'goal-fields.goal-start-date.cancel-button': 'Uložit',
  'goal-fields.goal-start-date.creation-date': 'Tento cíl byl vytvořen {creationDate}',
  'goal-fields.goal-start-date.edit-start-date-label': 'Upravit datum zahájení cíle',
  'goal-fields.goal-start-date.enter-start-date-title': 'Zadejte datum zahájení',
  'goal-fields.goal-start-date.open-calendar-label': 'Otevřít kalendář',
  'goal-fields.goal-start-date.title': 'Datum zahájení',
  'goal-fields.goal-status-picker.goal-status-lifecycle-picker-in-progress': 'Probíhá',
  'goal-fields.goal-status-picker.goal-status-lifecycle-picker-more-button': 'Více stavů',
  'goal-fields.goal-status-picker.goal-status-okr-current-status': 'Jaký je aktuální stav?',
  'goal-fields.goal-status-picker.goal-status-okr-help-content':
    'Pracujete s cíli a klíčovými výsledky? <link>Přečtěte si, jak používat cíle pro OKR.</link>',
  'goal-fields.goal-status-picker.goal-status-okr-help-info-icon-label': 'Odkaz na nápovědu',
  'goal-fields.goal-status.archived': 'Archivováno',
  'goal-fields.goal-status.at-risk': 'V ohrožení',
  'goal-fields.goal-status.cancelled': 'Zrušeno',
  'goal-fields.goal-status.completed': 'Dokončeno 🎉',
  'goal-fields.goal-status.off-track': 'Ve skluzu',
  'goal-fields.goal-status.on-track': 'Podle plánu',
  'goal-fields.goal-status.paused': 'Pozastaveno',
  'goal-fields.goal-status.pending': 'Čekající',
  'goal-fields.goal-status.title': 'Stav',
  'goal-fields.goal-sub-goals.add-sub-goals-title': 'Přidat dílčí cíle',
  'goal-fields.goal-sub-goals.unlink-sub-goal-tooltip': 'Odpojit dílčí cíl',
  'goal-fields.goal-tags.add-tags-title': 'Přidat štítky',
  'goal-fields.goal-tags.title': 'Štítky',
  'goal-fields.goal-target-date.picker-placeholder': 'Čekající',
  'goal-fields.goal-target-date.title': 'Cílové datum',
  'goal-fields.goal-type.goal': 'Cíl',
  'goal-fields.goal-type.key-result': 'Klíčový výsledek',
  'goal-fields.goal-type.objective': 'Dílčí cíl',
  'goal-fields.goal-type.title': 'Typ',
  'goal-fields.parent-goal.title': 'Nadřazený cíl',
  'goal-fields.sub-goals.title': 'Dílčí cíle',
  'goal-fields.teams.add-teams-title': 'Přidat týmy',
  'goal-fields.teams.follow-team': 'Sledovat tým',
  'goal-fields.teams.remove-team': 'Odebrat tým',
  'goal-fields.teams.search-team-placeholder': 'Vyhledat tým',
  'goal-fields.teams.show-more': 'Zobrazit více',
  'goal-fields.teams.title': 'Týmy',
  'goal-fields.teams.verified-team-label': 'Ověřený tým',
  'goal-fields.teams.view-profile': 'Zobrazit profil',
  'goal-fields.use-goal-flags.generic-error-description': 'Něco se pokazilo. Zkuste to znovu za pár minut.',
  'goal-fields.use-goal-flags.generic-error-title': 'Něco se pokazilo',
  'goal-fields.use-goal-flags.goal-owner-change-error-header': 'Změna vlastníka cíle se nezdařila',
  'goal-fields.use-goal-flags.goal-tags-add-failure-title': 'Přidání štítku se nezdařilo',
  'goal-fields.use-goal-flags.goal-tags-create-failure-title': 'Vytvoření štítku se nezdařilo',
  'goal-fields.use-goal-flags.goal-tags-create-limit-failure-description':
    'Název štítku, který jste zadali, je příliš dlouhý. Zadejte název štítku s 255 znaky nebo méně.',
  'goal-fields.use-goal-flags.goal-tags-create-limit-failure-title': 'Vytvoření štítku se nezdařilo',
  'goal-fields.use-goal-flags.goal-tags-remove-failure-title': 'Odebrání štítku se nezdařilo',
  'goal-fields.use-goal-flags.goal-teams-add-failure-title': 'Při přidávání týmu došlo k chybě. Zkuste to znovu.',
  'goal-fields.use-goal-flags.goal-teams-remove-failure-title': 'Při odebírání týmu došlo k chybě. Zkuste to znovu.',
  'goal-fields.use-goal-flags.parent-goal-change-error-header': 'Změna nadřazeného cíle se nezdařila',
  'goal-fields.use-goal-flags.start-date-change-error-header': 'Změna data zahájení se nezdařila',
  'goal-fields.use-goal-flags.target-date-change-error-header': 'Změna cílového data se nezdařila',
  'townsquare.goal-fields.tag': 'Odebrat štítek',
  'townsquare.goal-fields.tooltip-usage-count':
    '{usageCount, plural, one {Používá se na {usageCount,number} místě} few {Používá se na {usageCount,number} místech} many {Používá se na {usageCount,number} místa} other {Používá se na {usageCount,number} místech}}',
};
